import React, { useState, useEffect, useRef } from "react";
import $ from 'jquery';
import 'flexslider/flexslider.css';
window.jQuery = window.$ = $;
require("flexslider");
import "./style.scss";

let slider;
	
export const FlexSlider = props => {
    
	const sliderEl = useRef(null);
	const length = props.items ? props.items.length : 0;
	
    useEffect(() => {
		
        slider = $(sliderEl.current).flexslider({
            animation: "slide",
			slideshow: false,
			touch: true,
            controlNav: false,
			keyboard: false,
			pauseOnHover: true,
            rtl: props.rtl,
            startAt: props.startAt,
            customDirectionNav: $(".custom-navigation a"),
            init: () => {
               props.init();
            },
            start: (slider) => {
                $(slider).find(".slides li").attr("aria-selected","false");
                $(slider).find(".slides li.flex-active-slide").attr("aria-selected","true");

                $(slider).find(".slides .tabindex").attr("tabindex","-1");
                $(slider).find(".slides li.flex-active-slide .tabindex").attr("tabindex","0");
            },
            after: (slider) => {
                $(slider).find(".slides li").attr("aria-selected","false");
                $(slider).find(".slides li.flex-active-slide").attr("aria-selected","true");

                $(slider).find(".slides .tabindex").attr("tabindex","-1");
                $(slider).find(".slides li.flex-active-slide .tabindex").attr("tabindex","0");
                props.after(slider);
            }
        })

		return () => {
			slider.detach();
		}
    }, [length]);

    return (
        <div id={props.id} className="fs-container mt-5 pt-2">
            <div className="flexslider" role="tablist" ref={sliderEl}>
                <ul className="slides">
                    {props.items.map((item, i) => 
                      <li role="tabpanel" key={i}>
                        {item}
                      </li>
                    )}
                </ul>
            </div>
			<div className="custom-navigation">
				<a href="#" className="slider-arrow flex-next"></a>
				<a href="#" className="slider-arrow flex-prev"></a>
			</div>
        </div>
    );
};
